import { useState } from "react";


export const useModalVinculacionNatural = () => {

    const [openModalCustom, setOpenModalCustom] = useState({
        DeclaredEconomicActivity: false,
        NetIncomeDifferentMainActivity: false,
        FinancialSystemAccount: false
    });


    const [editObject, setEditObject] = useState({
        DeclaredEconomicActivity: {},
        NetIncomeDifferentMainActivity: {},
        FinancialSystemAccount: {}
    });


    const handleModalCustom = (e, type) => {
        setOpenModalCustom(prev => ({
            ...prev,
            [type]: true
        }));
    };



    const handleEditModalCustom = (e, type, object) => {
        setOpenModalCustom(prev => ({
            ...prev,
            [type]: true
        }));

        setEditObject(prev => ({
            ...prev,
            [type]: object
        }));

    }


    const handleCloseCustom = (type) => {
        setOpenModalCustom(prev => ({
            ...prev,
            [type]: false
        }));

        setEditObject(prev => ({
            ...prev,
            [type]: {}
        }));

    };





    return {

        openModalCustom,
        setOpenModalCustom,
        editObject,
        setEditObject,
        handleModalCustom,
        handleEditModalCustom,
        handleCloseCustom

    };

};